/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'I dag',
  now: 'Nu',
  backToToday: 'GÃ¥ til i dag',
  ok: 'Ok',
  clear: 'Annuller',
  month: 'MÃ¥ned',
  year: 'Ãr',
  timeSelect: 'VÃ¦lg tidspunkt',
  dateSelect: 'VÃ¦lg dato',
  monthSelect: 'VÃ¦lg mÃ¥ned',
  yearSelect: 'VÃ¦lg Ã¥r',
  decadeSelect: 'VÃ¦lg Ã¥rti',
  yearFormat: 'YYYY',
  dateFormat: 'D/M/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D/M/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Forrige mÃ¥ned(PageUp)',
  nextMonth: 'NÃ¦ste mÃ¥ned (PageDown)',
  previousYear: 'Forrige Ã¥r (Control + left)',
  nextYear: 'NÃ¦ste r (Control + right)',
  previousDecade: 'Forrige Ã¥rti',
  nextDecade: 'NÃ¦ste Ã¥rti',
  previousCentury: 'Forrige Ã¥rhundrede',
  nextCentury: 'NÃ¦ste Ã¥rhundrede'
};
